module.exports = __webpack_public_path__ + "img/u10.d068d466.png";